import { useCallback } from 'react';

import type { ISortedAvailableShift, ISortedGroupedSchedule, ISortedShift } from '@/types/schedule';

import { checkCollision } from '@/helpers';
import { ShiftAssignStatus } from '@/store/enums';
import { useTimezone } from './use-timezone';
import { CachedBlock } from '@/classes/cachedBlock';

interface IReturn {
  checkCollisionWithSchedule: (
    availableShift: ISortedShift<ISortedAvailableShift>,
    mySchedules: ISortedShift<ISortedGroupedSchedule>[],
  ) => boolean;
}

const useCheckCollisionWithSchedule = (): IReturn => {
  const { timezoneName } = useTimezone();

  const checkCollisionWithSchedule = useCallback<IReturn['checkCollisionWithSchedule']>(
    (availableShift, mySchedules) => {
      const availableShiftBlockData = CachedBlock.fromBlockId(availableShift.itemData.startBlock, timezoneName);
      let status = false;

      if (!mySchedules.length || !availableShiftBlockData) {
        return false;
      }

      mySchedules
        .filter(schedule => schedule.dayNumber === Number(availableShiftBlockData.day))
        .every(schedule => {
          if (
            schedule.hasVto &&
            schedule.shifts.some(shift => shift.shiftAssnStatus === ShiftAssignStatus.vtoAccepted)
          ) {
            status = false;
            return true;
          }

          status = checkCollision(availableShift.displayBlocks, schedule.displayBlocks);
          return !status; // if status === true then break the loop (with return false)
        });

      return status;
    },
    [timezoneName],
  );

  return {
    checkCollisionWithSchedule,
  };
};

export { useCheckCollisionWithSchedule };
